import { container } from '@shared/common/dependency-injection/domain/container';
import type { CurrentClientUserSelectedClientService } from '@client/entity/current-client-user/domain/service/current-client-user-selected-client.service';
import { CurrentClientUserDependencyTypes } from '@client/entity/current-client-user/current-client-user.dependency-types';
import type { RouteLocationRaw } from 'vue-router';

type CheckClientHasSubscriptionOptions = {
  redirectTo?: RouteLocationRaw;
};

export function checkClientHasSubscription(
  options: CheckClientHasSubscriptionOptions = {},
): true | false | RouteLocationRaw {
  const selectedClientService = container.get<CurrentClientUserSelectedClientService>(
    CurrentClientUserDependencyTypes.CurrentClientUserSelectedClientService,
  );
  const selectedClient = selectedClientService.getSelectedClient();

  if (selectedClient?.hasActiveSubscription) {
    return true;
  }

  return options.redirectTo ?? false;
}
